import React, { FunctionComponent } from 'react'
import { useFormContext } from 'react-hook-form'
import { Dropdown } from '@afterpaytouch/core'
import { DropdownFieldSchema } from '../../types'
import { useError, useVisible } from '../../utils/hooks'

export const DropdownField: FunctionComponent<DropdownFieldSchema> = ({ name = '', props, options, show = true, items, testNameSpace = '' }) => {
  const { register, setValue } = useFormContext()
  const { isVisible, values } = useVisible({ name, show })
  const defaultValue = values ?? props?.defaultValue
  const { isError, errorText } = useError({ name, error: props?.error, errorText: props?.errorText })

  const component = register(name, {
    ...options,
    value: defaultValue,
  })

  const handleCustomSelect = (selectedValue: string): void => {
    setValue(name, selectedValue, { shouldValidate: true, shouldTouch: true, shouldDirty: defaultValue !== selectedValue })
    if (props?.onSelect != null) {
      props.onSelect(selectedValue)
    }
  }

  return isVisible ? (
    <Dropdown
      {...props}
      ref={component.ref}
      name={component.name}
      testNameSpace={testNameSpace}
      onSelect={handleCustomSelect}
      onBlur={component.onBlur}
      error={isError}
      errorText={errorText}
    >
      {items?.map((item) => (
        <Dropdown.MenuItem key={item.key} value={item.key}>
          {item.label}
        </Dropdown.MenuItem>
      ))}
    </Dropdown>
  ) : null
}
